import React, { useContext } from 'react';
import CustomizePageContext from '../CustomizeContext/CustomizePageContext';
import LanguageCountrySelector from '../../../components/LanguageCountrySelector';

const CustomizeLanguageSelector = () => {
  const { languageOptions, countryOptions, selectedLanguage, handleSelectLanguage } =
    useContext(CustomizePageContext);

  return (
    <LanguageCountrySelector
      languageOptions={languageOptions}
      countryOptions={countryOptions}
      selectedLanguage={selectedLanguage}
      handleSelectLanguage={handleSelectLanguage}
    />
  );
};

export default CustomizeLanguageSelector;
